import MissionService from "@/services/mission.service.js";
import MissionFormatter from "@/helpers/formatters/mission.formatter.js";

class MissionRepository {

    async getFinished(filters = {}) {
        const {
            page = 1,
            perPage = 15,
            startDate = null,
            endDate = null
        } = filters;

        const res = await MissionService.getFinishedMissions({
            page,
            perPage,
            startDate,
            endDate
        });

        return MissionFormatter.missionsSearchFormat(res.data, page, perPage);
    }

    async getMission(id) {
        const res = await MissionService.getMission(id);
        return MissionFormatter.missionFormat(res.data);
    }

    async getOngoing() {
        const res = await MissionService.getOngoingMissions();
        return MissionFormatter.missionsFormat(res.data);
    }

    async getPending() {
        const res = await MissionService.getPendingMissions();
        return MissionFormatter.missionsFormat(res.data);
    }
}

export default new MissionRepository();